import { Component } from '@angular/core';
import { PlatformWidgetComponent } from '../platform-widget.component';
import { OrganizationService } from '@markant-platform/shared/organization/data-access';
import { AuthenticatedUserService } from '@markant-platform/shared/user/data-access';
import { Observable, switchMap } from 'rxjs';

@Component({
  selector: 'markant-platform-further-qualification-progress-widget',
  templateUrl: './further-qualification-progress-widget.component.html',
  styleUrls: ['./further-qualification-progress-widget.component.scss'],
})
export class FurtherQualificationProgressWidgetComponent extends PlatformWidgetComponent {
  status: Observable<{ adminVerified: boolean; approvedByBackoffice: boolean }>;

  constructor(
    private readonly organizationService: OrganizationService,
    private readonly authenticatedUserService: AuthenticatedUserService
  ) {
    super();
    this.status = this.authenticatedUserService
      .getOrganizationId()
      .pipe(
        switchMap(organizationId =>
          this.organizationService.getFurtherQualificationRequestForOrganization(organizationId)
        )
      );
  }
}
